import axios from "axios";
import React, { useState , useEffect } from "react";

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { FaFileExcel, FaFilePdf } from "react-icons/fa";


const Saleswisereport = ({clientData}) => {


  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [data, setData] = useState([]);
  const [reportType, setReportType] = useState("product");
  const [productData, setProductData] = useState([]);
const [categoryData, setCategoryData] = useState([]);

const fetchSaleHistory = async () => {
  try {
    let url = `https://api.dectwinbilling.com/fetch-sale-history-report/${clientData.id}`;

    const params = new URLSearchParams();

    if (fromDate) {
      params.append("fromDate", fromDate);
    }

    if (toDate) {
      params.append("toDate", toDate);
    }

    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    const res = await axios.get(url);

    const sales = res.data || [];



    processSalesData(sales);

  } catch (error) {
    console.error("Sale history error:", error);
  }
};

useEffect(() => {
  if (clientData?.id) {
    fetchSaleHistory();
  }
}, [clientData?.id, fromDate, toDate]);

const processSalesData = (sales) => {
  try {
    const latest10Sales = [...sales]
      .sort((a, b) => {
        return new Date(b.date) - new Date(a.date);
      })
      .slice(0, 10);

    const productMap = {};
    const categoryMap = {};
    latest10Sales.forEach((sale) => {

      let items = sale.items

      try {

        if (typeof items === "string") {

          items = JSON.parse(items);
          if (typeof items === "string") {
            items = JSON.parse(items);
          }

        }

      } catch (error) {

        console.error(
          "Unable to parse items for sale:",
          sale.id,
          sale.items,
          error
        );

        return;
      }

      if (!Array.isArray(items)) {

        console.warn(
          "Items is not an array for sale:",
          sale.id,
          items
        );

        return;
      }

      items.forEach((item) => {

        if (!item || typeof item !== "object") {
          return;
        }
        const itemName =
          String(item.name || "Unknown Item").trim();


        const categoryName =
          String(
            item.category || "No Category"
          ).trim();


        const type = 'Sale'

        const quantity =
          Number(item.quant) || 0;


        const purchasePrice =
          Number(item.pur_price) || 0;


        const salePrice =
          Number(item.price_per_unit) || 0;


        const discount =
          Number(item.discount) || 0;
      const totalPP =
          purchasePrice * quantity;
        const totalSP =
          salePrice * quantity;
        const totalProfit =
          totalSP -
          totalPP -
          discount;

        if (!productMap[itemName]) {

          productMap[itemName] = {

            itemName,

            type,

            soldQuantity: 0,

            purchasePrice: 0,

            salePrice: 0,

            totalPP: 0,

            totalSP: 0,

            totalDiscount: 0,

            totalProfit: 0,

          };

        }


        productMap[itemName].soldQuantity =
          quantity;


        productMap[itemName].purchasePrice =
          purchasePrice;


        productMap[itemName].salePrice =
          salePrice;


        productMap[itemName].totalPP =
          totalPP;


        productMap[itemName].totalSP =
          totalSP;


        productMap[itemName].totalDiscount =
          discount;


        productMap[itemName].totalProfit =
          totalProfit;

        if (!categoryMap[categoryName]) {

          categoryMap[categoryName] = {

            categoryName,

            soldQuantity: 0,

            purchasePrice: 0,

            salePrice: 0,

            totalPP: 0,

            totalSP: 0,

            totalDiscount: 0,

            totalProfit: 0,

          };

        }


        categoryMap[categoryName].soldQuantity =
          quantity;


        categoryMap[categoryName].totalPP =
          totalPP;


        categoryMap[categoryName].totalSP =
          totalSP;


        categoryMap[categoryName].totalDiscount =
          discount;


        categoryMap[categoryName].totalProfit =
          totalProfit;

      });

    });
    const products =
      Object.values(productMap);


    const categories =
      Object.values(categoryMap);

    categories.forEach((category) => {

      if (category.soldQuantity > 0) {

        category.purchasePrice =
          category.totalPP /
          category.soldQuantity;


        category.salePrice =
          category.totalSP /
          category.soldQuantity;

      }

    });

    setProductData(products);

    setCategoryData(categories);

  } catch (error) {

    console.error(
      "processSalesData error:",
      error
    );

  }
};




const exportToPDF = () => {
  const isProduct = reportType === "product";

  const currentData = isProduct
    ? productData
    : categoryData;

  const reportTitle = isProduct
    ? "Productwise Sales Report"
    : "Categorywise Sales Report";

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

  // ================= TITLE =================

  doc.setFontSize(18);
  doc.setFont("helvetica", "bold");

  doc.text(
    reportTitle,
    148,
    15,
    { align: "center" }
  );

  // ================= GENERATED DATE =================

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");

  doc.text(
    `Generated On: ${new Date().toLocaleString()}`,
    148,
    23,
    { align: "center" }
  );

  // ================= DATE RANGE =================

  doc.text(
    `From: ${fromDate || "All"}`,
    14,
    32
  );

  doc.text(
    `To: ${toDate || "All"}`,
    14,
    39
  );

  // ================= PRODUCT REPORT =================

  if (isProduct) {

    autoTable(doc, {
      startY: 46,

      head: [[
        "Item Name",
        "Transaction Type",
        "Sold Quantity",
        "Pur. Price",
        "Sale Price",
        "Total PP",
        "Total SP",
          "Total Dis",
        "Total Profit",
      ]],

      body: currentData.map((item) => [
        item.itemName || "-",
        item.type || "Sale",

        Number(
          item.soldQuantity || 0
        ).toFixed(1),

        Number(
          item.purchasePrice || 0
        ).toFixed(2),

        Number(
          item.salePrice || 0
        ).toFixed(2),

        Number(
          item.totalPP || 0
        ).toFixed(2),

        Number(
          item.totalSP || 0
        ).toFixed(2),

          Number(item.totalDiscount || 0).toFixed(2),

        Number(
          item.totalProfit || 0
        ).toFixed(2),
      ]),

      theme: "grid",

      styles: {
        fontSize: 8,
        cellPadding: 2,
        valign: "middle",
      },

      headStyles: {
        fillColor: [100, 100, 100],
        textColor: [255, 255, 255],
        fontStyle: "bold",
        fontSize: 8,
      },

      columnStyles: {
        0: { cellWidth: 35 },
        1: { cellWidth: 35 },
        2: { cellWidth: 28 },
        3: { cellWidth: 25 },
        4: { cellWidth: 25 },
        5: { cellWidth: 25 },
        6: { cellWidth: 25 },
        7: { cellWidth: 28 },
         8: { cellWidth: 25 },
      },
    });

  } else {

    // ================= CATEGORY REPORT =================

    autoTable(doc, {
      startY: 46,

      head: [[
        "Category Name",
        "Sold Quantity",
        "Avg. Pur. Price",
        "Avg. Sale Price",
        "Total PP",
        "Total SP",
        "Total Dis",
        "Total Profit",
      ]],

      body: currentData.map((item) => [
        item.categoryName || "-",

        Number(
          item.soldQuantity || 0
        ).toFixed(1),

        Number(
          item.purchasePrice || 0
        ).toFixed(2),

        Number(
          item.salePrice || 0
        ).toFixed(2),

        Number(
          item.totalPP || 0
        ).toFixed(2),

        Number(
          item.totalSP || 0
        ).toFixed(2),

        Number(
          item.totalDiscount || 0
        ).toFixed(2),

        Number(
          item.totalProfit || 0
        ).toFixed(2),
      ]),

      theme: "grid",

      styles: {
        fontSize: 8,
        cellPadding: 2,
        valign: "middle",
      },

      headStyles: {
        fillColor: [100, 100, 100],
        textColor: [255, 255, 255],
        fontStyle: "bold",
        fontSize: 8,
      },

      columnStyles: {
        0: { cellWidth: 35 },
        1: { cellWidth: 28 },
        2: { cellWidth: 30 },
        3: { cellWidth: 30 },
        4: { cellWidth: 25 },
        5: { cellWidth: 25 },
        6: { cellWidth: 25 },
        7: { cellWidth: 28 },
      },
    });
  }

  // ================= SAVE =================

  doc.save(
    `${isProduct ? "Productwise_Sales" : "Categorywise_Sales"}_Report_${Date.now()}.pdf`
  );
};


const exportToExcel = async () => {
  const isProduct = reportType === "product";

  const currentData = isProduct
    ? productData
    : categoryData;

  const reportTitle = isProduct
    ? "Item Wise Profit & Loss Report"
    : "Category Wise Profit & Loss Report";

  const workbook = new ExcelJS.Workbook();

  const worksheet = workbook.addWorksheet(
    isProduct
      ? "Product Sales Report"
      : "Category Sales Report"
  );

  // ================= TITLE =================

  worksheet.addRow([reportTitle]);

  worksheet.mergeCells("A1:I1");

  const title = worksheet.getCell("A1");

  title.font = {
    bold: true,
    size: 18,
    color: { argb: "FFFFFF" },
  };

  title.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "1F4E78" },
  };

  title.alignment = {
    horizontal: "center",
    vertical: "middle",
  };

  worksheet.getRow(1).height = 30;

  // ================= DATE =================

  worksheet.addRow([]);

  worksheet.addRow([
    "Generated on:",
    new Date().toLocaleString(),
  ]);

  worksheet.addRow([]);

  worksheet.addRow([
    "From:",
    fromDate || "All",
    "To:",
    toDate || "All",
  ]);

  worksheet.addRow([]);

  // ================= PRODUCT =================

  if (isProduct) {

    worksheet.addRow([
      "Item Name",
      "Transaction Type",
      "Sold Quantity",
      "Purchase Price",
      "Sale Price",
      "Total Pur. Price",
      "Total Sales Price",
        "Total Dis",
      "Total Profit",
    ]);

    const header = worksheet.getRow(6);

    header.font = {
      bold: true,
      color: { argb: "000000" },
    };

    header.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "00FFFF" },
    };

    header.alignment = {
      horizontal: "center",
      vertical: "middle",
    };

    // DATA

    currentData.forEach((item) => {

      worksheet.addRow([
        item.itemName || "-",

        item.type || "Sale",

        Number(
          item.soldQuantity || 0
        ).toFixed(1),

        Number(
          item.purchasePrice || 0
        ).toFixed(2),

        Number(
          item.salePrice || 0
        ).toFixed(2),

        Number(
          item.totalPP || 0
        ).toFixed(2),

        Number(
          item.totalSP || 0
        ).toFixed(2),
         Number(item.totalDiscount || 0).toFixed(2),

        Number(
          item.totalProfit || 0
        ).toFixed(2),
      ]);

    });

  } else {

    // ================= CATEGORY =================

    worksheet.addRow([
      "Category Name",
      "Sold Quantity",
      "Avg. Pur. Price",
      "Avg. Sale Price",
      "Total PP",
      "Total SP",
      "Total Dis",
      "Total Profit",
    ]);

    const header = worksheet.getRow(6);

    header.font = {
      bold: true,
      color: { argb: "000000" },
    };

    header.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "00FFFF" },
    };

    header.alignment = {
      horizontal: "center",
      vertical: "middle",
    };

    // DATA

    currentData.forEach((item) => {

      worksheet.addRow([
        item.categoryName || "-",

        Number(
          item.soldQuantity || 0
        ).toFixed(1),

        Number(
          item.purchasePrice || 0
        ).toFixed(2),

        Number(
          item.salePrice || 0
        ).toFixed(2),

        Number(
          item.totalPP || 0
        ).toFixed(2),

        Number(
          item.totalSP || 0
        ).toFixed(2),

        Number(
          item.totalDiscount || 0
        ).toFixed(2),

        Number(
          item.totalProfit || 0
        ).toFixed(2),
      ]);

    });
  }

  // ================= COLUMN WIDTH =================

  worksheet.columns = [
    { width: 25 },
    { width: 22 },
    { width: 18 },
    { width: 18 },
    { width: 18 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
      { width: 20 },
  ];

  // ================= BORDERS =================

  worksheet.eachRow((row) => {

    row.eachCell((cell) => {

      cell.border = {
        top: {
          style: "thin",
        },

        left: {
          style: "thin",
        },

        bottom: {
          style: "thin",
        },

        right: {
          style: "thin",
        },
      };

      cell.alignment = {
        vertical: "middle",
      };

    });

  });

  // ================= FREEZE HEADER =================

  worksheet.views = [
    {
      state: "frozen",
      ySplit: 6,
    },
  ];

  // ================= DOWNLOAD =================

  const buffer =
    await workbook.xlsx.writeBuffer();

  saveAs(
    new Blob([buffer]),
    `${
      isProduct
        ? "Productwise_Sales"
        : "Categorywise_Sales"
    }_Report_${Date.now()}.xlsx`
  );
};

  return (
    <div className="container-fluid mt-3">


      
  <div className="row mb-3">

  <div className="col-6 col-md-6">
    <label className="form-label fw-bold">From Date</label>
    <input
      type="date"
      className="form-control w-100 w-md-50"
      style={{ maxWidth: "220px" }}
      value={fromDate}
       onChange={(e) => {
        setFromDate(e.target.value);

        if (toDate && e.target.value > toDate) {
          setToDate("");
        }
      }}
    />
  </div>

  <div className="col-6 col-md-6 d-flex flex-column align-items-md-end">
    <label className="form-label fw-bold">To Date</label>
    <input
      type="date"
      className="form-control w-100"
      style={{ maxWidth: "220px" }}
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
    />
  </div>

</div>
      <div className="card shadow border-0">

        <div className="card-header bg-primary text-white fw-bold">
          Sales Wise Report
        </div>


    
<div className="table-responsive">
  {reportType === "product" ? (
    // ================= PRODUCT TABLE =================
    <table className="table table-bordered text-center mb-0">

      <thead>
        <tr
          style={{
            backgroundColor: "#b36ac7",
            color: "#fff",
          }}
        >
          <th>Item Name</th>
          <th>Type</th>
          <th>Sold Quantity</th>
          <th>Pur. Price</th>
          <th>Sale Price</th>
          <th>Total PP</th>
          <th>Total SP</th>
          <th>Total Dis</th>
          <th>Total Profit</th>
        </tr>
      </thead>

      <tbody>

  {productData.length > 0 ? (

    productData.map((item, index) => (

      <tr key={index}>

        <td>
          {item.itemName}
        </td>

        <td>
          {item.type}
        </td>

        <td>
          {item.soldQuantity}
        </td>

        <td>
          ₹ {item.purchasePrice.toFixed(2)}
        </td>

        <td>
          ₹ {item.salePrice.toFixed(2)}
        </td>

        <td>
          ₹ {item.totalPP.toFixed(2)}
        </td>

        <td>
          ₹ {item.totalSP.toFixed(2)}
        </td>

        <td>
          ₹ {item.totalDiscount.toFixed(2)}
        </td>

        <td>
          ₹ {item.totalProfit.toFixed(2)}
        </td>

      </tr>

    ))

  ) : (

    <tr>

      <td
        colSpan="9"
        className="text-center py-3"
      >
        No product sales found
      </td>

    </tr>

  )}

</tbody>

   

    </table>

  ) : (

    // ================= CATEGORY TABLE =================
    <table className="table table-bordered text-center mb-0">

      <thead>
        <tr
          style={{
            backgroundColor: "#36a6a6",
            color: "#fff",
          }}
        >
        <th>Category Name</th>

    <th>Sold Quantity</th>

    <th>Avg. Pur. Price</th>

    <th>Avg. Sale Price</th>

    <th>Total PP</th>

    <th>Total SP</th>

    <th>Total Dis</th>

    <th>Total Profit</th>

        </tr>
      </thead>

      <tbody>

  {categoryData.length > 0 ? (

    categoryData.map((item, index) => (

      <tr key={index}>

        <td>
          {item.categoryName}
        </td>

        <td>
          {item.soldQuantity}
        </td>

        <td>
          ₹ {item.purchasePrice.toFixed(2)}
        </td>

        <td>
          ₹ {item.salePrice.toFixed(2)}
        </td>

        <td>
          ₹ {item.totalPP.toFixed(2)}
        </td>

        <td>
          ₹ {item.totalSP.toFixed(2)}
        </td>

        <td>
          ₹ {item.totalDiscount.toFixed(2)}
        </td>

        <td>
          ₹ {item.totalProfit.toFixed(2)}
        </td>

      </tr>

    ))

  ) : (

    <tr>

      <td
        colSpan="8"
        className="text-center py-3"
      >
        No category sales found
      </td>

    </tr>

  )}



      </tbody>

    </table>

  )}
</div>

      {/* <div className="row m-2">
  <div>

    <button
      type="button"
      onClick={() => setReportType("product")}
      className={`btn me-2 ${
        reportType === "product"
          ? "btn-success"
          : "btn-outline-success"
      }`}
    >
      Product
    </button>


    <button
      type="button"
      onClick={() => setReportType("category")}
      className={`btn ${
        reportType === "category"
          ? "btn-warning"
          : "btn-outline-warning"
      }`}
    >
      Category
    </button>

  </div>
</div> */}

<div className="d-flex justify-content-between align-items-center mt-3 mb-3 flex-wrap gap-3">

  {/* ================= LEFT SIDE ================= */}

  <div className="d-flex align-items-center gap-2">

    <button
      type="button"
      onClick={() => setReportType("product")}
      className={`btn ${
        reportType === "product"
          ? "btn-success"
          : "btn-outline-success"
      }`}
    >
      Product
    </button>

    <button
      type="button"
      onClick={() => setReportType("category")}
      className={`btn ${
        reportType === "category"
          ? "btn-warning"
          : "btn-outline-warning"
      }`}
    >
      Category
    </button>

  </div>


  {/* ================= RIGHT SIDE ================= */}

  <div className="d-flex align-items-center gap-2 m-2">

    {/* EXCEL */}

    <button
      type="button"
      className="btn d-flex align-items-center gap-2 px-4 py-2 shadow"
      onClick={exportToExcel}
      style={{
        background:
          "linear-gradient(135deg, #28a745, #198754)",
        color: "#fff",
        border: "none",
        borderRadius: "10px",
        fontWeight: "600",
        transition: "0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform =
          "translateY(-2px)";

        e.currentTarget.style.boxShadow =
          "0 8px 20px rgba(25,135,84,0.35)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform =
          "translateY(0)";

        e.currentTarget.style.boxShadow = "";
      }}
    >
      <FaFileExcel size={20} />
      Excel
    </button>


    {/* PDF */}

    <button
      type="button"
      className="btn d-flex align-items-center gap-2 px-4 py-2 shadow"
      onClick={exportToPDF}
      style={{
        background:
          "linear-gradient(135deg, #dc3545, #b02a37)",
        color: "#fff",
        border: "none",
        borderRadius: "10px",
        fontWeight: "600",
        transition: "0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform =
          "translateY(-2px)";

        e.currentTarget.style.boxShadow =
          "0 8px 20px rgba(220,53,69,0.35)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform =
          "translateY(0)";

        e.currentTarget.style.boxShadow = "";
      }}
    >
      <FaFilePdf size={20} />
      PDF
    </button>

  </div>

</div>
      </div>
    </div>
  );
};

export default Saleswisereport;